import { render, staticRenderFns } from "./TransporterDriverProfile.vue?vue&type=template&id=53b5bca3&scoped=true&"
import script from "./TransporterDriverProfile.vue?vue&type=script&lang=js&"
export * from "./TransporterDriverProfile.vue?vue&type=script&lang=js&"
import style0 from "./TransporterDriverProfile.vue?vue&type=style&index=0&id=53b5bca3&scoped=true&lang=css&"
import style1 from "./TransporterDriverProfile.vue?vue&type=style&index=1&id=53b5bca3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5bca3",
  null
  
)

export default component.exports